export default function dateToString(date: string) {
  const day = date.substr(8, 2)
  const month = date.substr(5, 2)
  const year = date.substr(0, 4)
  return day + '/' + month + '/' + year
}
